<div class="dashboard-container">
    <div class="d-flex align-items-center mb-4">
        <h4 class="flex-grow-1 mb-0">Organizations</h4>
        @if (canManageOrganizations$ | async) {
            <button id="dashboard-create-app" mat-raised-button color="primary" (click)="goToCreateApp()">
                Create App
            </button>
        }
    </div>
    <div class="table-container d-flex p-3 w-100">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!-- Logo Column -->
            <ng-container matColumnDef="logo">
                <th mat-header-cell *matHeaderCellDef>Logo</th>
                <td mat-cell *matCellDef="let element">
                    <img [src]="element.mainLogoLightUrl" alt="logo" width="50" />
                </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Org Name</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.organizationName }}
                </td>
            </ng-container>

            <!-- Hosting URL Column -->
            <ng-container matColumnDef="hostingUrl">
                <th mat-header-cell *matHeaderCellDef>Hosting URL</th>
                <td mat-cell *matCellDef="let element">
                    @if (!element.hostingUrl?.length) {
                        <mat-spinner diameter="20"></mat-spinner>
                    } @else {
                        <div class="app_url d-flex">
                            <a
                                id="hosting-link-{{ element.id }}"
                                [href]="element.hostingUrl"
                                target="_blank"
                                class="d-flex align-items-center text-decoration-none"
                            >
                                <mat-icon>open_in_new</mat-icon></a
                            >
                        </div>
                    }
                </td>
            </ng-container>

            <!-- Status URL Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element" class="text-uppercase">
                    {{ element.status || 'N/A' }}
                </td>
            </ng-container>

            <!-- Verification Column -->
            <ng-container matColumnDef="verification">
                <th mat-header-cell *matHeaderCellDef>Verification</th>
                <td mat-cell *matCellDef="let element">
                    <app-verification-checks
                        [orgId]="element.id!"
                        [verificationChecks]="element.verificationChecks"
                        [disabled]="!(canManageOrganizations$ | async)"
                        [status]="element.status"
                        [verificationStage]="element.verificationStage"
                        [adyenActivationStatus]="element.adyenActivationStatus"
                        [adyenActivationError]="element.adyenActivationError"
                        (verificationChange)="onVerificationChange(element.id!, $event)"
                    />
                </td>
            </ng-container>

            <!-- Primary contact -->
            <ng-container matColumnDef="primaryContactName">
                <th mat-header-cell *matHeaderCellDef>Contact Name</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.primaryContactName }}
                </td>
            </ng-container>

            <!-- Contact phone -->
            <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef>Phone</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.phone }}
                </td>
            </ng-container>

            <!-- Contact email -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.contactEmail }}
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                    @if (canManageOrganizations$ | async) {
                        <button mat-button (click)="goToEditApp(element.id)" id="edit-{{ element.id }}">Edit</button>
                        @if (!element.status || element.status === 'active') {
                            <button
                                id="delete-{{ element.id }}"
                                mat-button
                                color="warn"
                                (click)="onPressDelete(element.id, element.organizationName)"
                            >
                                Delete
                            </button>
                        }
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [ngClass]="{ 'disabled-row': row.status === 'disabled' }"
            ></tr>
        </table>
    </div>
</div>
